var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goback",on:{"click":_vm.goBack}},[_c('i',{staticClass:"el-icon-arrow-left"}),_c('span',{staticClass:"title"},[_vm._v("返回")])])
}
var staticRenderFns = []

export { render, staticRenderFns }